import { lazy } from 'react';
// import AddServiceRequest from '../pages/addServiceRequest.page';

// ----------------------------------------------------------------------

const ProductsPage = lazy(() => import('../pages/Products.page'));

// ----------------------------------------------------------------------

const ProductsListRoutes = [
    {
        path: '/products',
        children: [
            { element: <ProductsPage />, layout: 'default', isAuthReq: true, index: true },
         
        ],
    },
];

export { ProductsListRoutes };
